// extracted by mini-css-extract-plugin
export default {"wrapper":"SD-z","button":"TD-z","alternate":"UD-z","disabled":"VD-z","paymentWarning":"WD-z","fadeIn":"XD-z"};